// Format an Aadhar number as 0000-0000-0000 regardless of how it was stored
// (works for old records stored as plain digits and new dashed ones)
export const formatAadhar = (value) => {
  if (!value) return value;
  const digits = String(value).replace(/\D/g, '').slice(0, 12);
  return digits.replace(/(\d{4})(?=\d)/g, '$1-');
};

// Convert "HH:MM" (24h) to "h:MM AM/PM"
export const to12 = (hhmm) => {
  if (!hhmm || !hhmm.includes(':')) return '';
  const [h, m] = hhmm.split(':').map(Number);
  const ampm = h >= 12 ? 'PM' : 'AM';
  const h12 = ((h + 11) % 12) + 1;
  return `${h12}:${String(m).padStart(2, '0')} ${ampm}`;
};

// Format decimal hours as "1h 30m"
export const formatHrsMins = (hours) => {
  const totalMins = Math.round((hours || 0) * 60);
  const h = Math.floor(totalMins / 60);
  const m = totalMins % 60;
  return `${h}h ${m}m`;
};

// Format a shift as "11:00 AM – 9:00 PM (10 hrs)" from "HH:MM" start/end
export const formatShift = (start, end) => {
  if (!start || !end) return '—';
  const [sh, sm] = start.split(':').map(Number);
  const [eh, em] = end.split(':').map(Number);
  let diff = (eh * 60 + em) - (sh * 60 + sm);
  if (diff <= 0) diff += 24 * 60;
  const hrs = Math.round((diff / 60) * 100) / 100;
  return `${to12(start)} – ${to12(end)} (${hrs} hrs)`;
};

// Format one OR MORE comma-separated Aadhar numbers, each as 0000-0000-0000
export const formatMultiAadhar = (value) => {
  if (!value) return value;
  return String(value)
    .split(',')
    .map((part) => part.replace(/\D/g, '').slice(0, 12).replace(/(\d{4})(?=\d)/g, '$1-'))
    .join(',');
};
